import React, { useState } from "react";
import { Box, VStack, Flex, Input, Button, Text } from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function DatabaseConfig() {
  const [clientHash, setClientHash] = useState("");
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [databasePath, setDatabasePath] = useState("");
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !clientHash.trim() ||
      !host.trim() ||
      !port.trim() ||
      !databasePath.trim() ||
      !user.trim() ||
      !password.trim()
    ) {
      toast.error("Todos os campos são obrigatórios.");
      return;
    }

    try {
      setLoading(true);
      await api.post("/client-database/config", {
        clientHash: clientHash.trim(),
        host: host.trim(),
        port: port.trim(),
        databasePath: databasePath.trim(),
        user: user.trim(),
        password: password.trim(),
      });

      toast.success("Configuração salva com sucesso.");
      setClientHash("");
      setHost("");
      setPort("");
      setDatabasePath("");
      setUser("");
      setPassword("");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Não foi possível salvar a configuração. Tente novamente.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" w="100%">
      <HeaderTools title="Database Config" />
      <Flex
        direction="column"
        align="center"
        justify="center"
        minH="calc(100vh - 80px)"
        px={{ base: 4, md: 6 }}
        py={{ base: 8, md: 12 }}
      >
        <Box
          bg="white"
          w="100%"
          maxW="600px"
          borderRadius="12px"
          boxShadow="lg"
          p={{ base: 6, md: 8 }}
        >
          <Text
            as="h1"
            fontSize={{ base: "22px", md: "26px" }}
            fontWeight="bold"
            mb={6}
          >
            Configuração do Banco de Dados
          </Text>

          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Client Hash
                </Text>
                <Input
                  value={clientHash}
                  onChange={(e) => setClientHash(e.target.value)}
                  placeholder="clientHash"
                  padding="15px"
                  required
                />
              </Box>

              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Host
                </Text>
                <Input
                  value={host}
                  onChange={(e) => setHost(e.target.value)}
                  placeholder="host"
                  padding="15px"
                  required
                />
              </Box>

              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Porta
                </Text>
                <Input
                  value={port}
                  onChange={(e) => setPort(e.target.value)}
                  placeholder="port"
                  padding="15px"
                  required
                />
              </Box>

              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Caminho do Banco de Dados
                </Text>
                <Input
                  value={databasePath}
                  onChange={(e) => setDatabasePath(e.target.value)}
                  placeholder="databasePath"
                  padding="15px"
                  required
                />
              </Box>

              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Usuário
                </Text>
                <Input
                  padding="15px"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  placeholder="user"
                  required
                />
              </Box>

              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Senha
                </Text>
                <Input
                  type="password"
                  padding="15px"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="password"
                  required
                />
              </Box>

              <Button
                type="submit"
                bg="black"
                color="white"
                size="lg"
                fontSize={{ base: "16px", md: "18px" }}
                fontWeight="semibold"
                px={{ base: 8, md: 12 }}
                py={{ base: 6, md: 7 }}
                h={{ base: "50px", md: "56px" }}
                borderRadius="8px"
                _hover={{ bg: "gray.800" }}
                _active={{ bg: "gray.900" }}
                isLoading={loading}
              >
                Salvar configuração
              </Button>
            </VStack>
          </form>
        </Box>
      </Flex>
    </Box>
  );
}
